import ContextMenuTrigger from "./ContextMenuTrigger";
import TableActionToolbar from './TableActionToolbar';
import StyleToolbar from './StyleToolbar';
import { SelectedItemInfo } from './SelectedItemProvider';
import { SelectedItemsContext } from './Contexts';
import TuneIcon from '@material-ui/icons/Tune';

import { useContext } from 'react';


export default function Toolbar({
  setRetainInputFocus,
  figurePanelId,
  popupMenuLocations,
  setPopupMenuLocations,
  setSelectedCells,
}){


  const selectedFigureItems = useContext(SelectedItemsContext);
  const { unifiedGroup } = useContext( SelectedItemInfo);



  return (
    <div id={"top-editor-toolbar"} style={{
      padding:5,
      //border:'2px solid red',
      //background:'blue',
      display:'flex',
      width:'100%'

     }} class="light-border-bottom">
      <div style={{alignItems:'center'}} class="sg-row v-center">
        <StyleToolbar { ...{
          figurePanelId,
          setRetainInputFocus,
          selectedFigureItems,
          unifiedGroup,
        }}/>

        <div class="toolbar-button hoverable sg-row v-center" style={{padding:4,borderRadius:5}}>
        <div 
          task={"Adjust Channels"}
          className="adjust-channels-button DO_NOT_DELETE"
          onClick={(e) => {
            let key = "channelSettings";
            let overwriteMap = {
              true:false,
              false:[e.clientX, e.clientY + 20]
            }
            let curValueBool = !!popupMenuLocations[key];
            let overwrite = {
              channelSettings:overwriteMap[ curValueBool ]
            }
            setPopupMenuLocations({...popupMenuLocations,...overwrite});

          }}>
          <TuneIcon style={{fontSize:16}}/>
        </div>
        </div>

        

        <ContextMenuTrigger {...{
          unifiedGroup,
          figurePanelId,
          setSelectedCells,
          selectedFigureItems,
        }}/>


        {false && <TableActionToolbar {...{
          unifiedGroup,
          figurePanelId,
          setSelectedCells,
          selectedFigureItems,
        }}/>}
        {false && <div class="flex-expand"/>}
        {/*false && <div>
          <button onClick={() => setPopupMenusToShow(cur => ({...cur,quantificationToolbar:!cur.quantificationToolbar}))}>
            {(popupMenusToShow.quantificationToolbar?"Hide":"Show") + " Quantification"}
          </button>
        </div>*/}
      </div>
    </div>
  )

}
